import { JsonColor, JsonWidgetData, mapColor, mapDataAvailability, mapDescription } from 'adapter/out/client/widgets/data/mappers/common';
import { SerieBorder } from 'domain/entity/widgets/ChartData';
import PieData from 'domain/entity/widgets/PieData';

export type JsonPieSeries = {
    title: string;
    value: number;
    color: JsonColor;
    ['fill_pattern']: string;
};

export type JsonPieData = JsonWidgetData & {
    data: {
        series: JsonPieSeries[];
        units: string;
        title: string;
    };
};

const asSeries = (json: JsonPieSeries) => ({
    title: json.title,
    value: json.value,
    color: mapColor(json.color),
    fillPattern: json.fill_pattern as SerieBorder,
});

export const asPieData = (json: JsonPieData): PieData =>
    new PieData(
        json.data.series.map(asSeries),
        json.data.units,
        json.data.title,
        mapDataAvailability(json.data_availability),
        mapDescription(json.description)
    );
